import type { ReactElement, ReactNode } from "react";
import { StyleSheet, View } from "react-native";
import { BodyText, Subtitle, Title } from "~/components/layout/text";
import { Radius, Space } from "~/constants/sizing";
import { useTheme } from "~/providers/ThemeProvider";
import { QendoIcon, type QendoIconSet } from "../QendoIcon";

type SectionHeaderProps = {
    title: string;
    subtitle?: string;
    header?: ReactNode;
    icon?: QendoIconSet;
    button?: () => ReactElement;
    children?: ReactNode;
};

export const SectionHeader = ({ title, subtitle, header, icon, button, children }: SectionHeaderProps) => {
    const { background } = useTheme();

    return (
        <View style={[styles.container, background.primary]}>
            {header}
            {icon && <QendoIcon name={icon} size={32} variant="secondary" />}
            <View style={styles.body}>
                <Title align="center">{title}</Title>
                {subtitle && <Subtitle align="center">{subtitle}</Subtitle>}
                {children && (
                    <BodyText size="md" align="center">
                        {children}
                    </BodyText>
                )}
            </View>
            {button?.()}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        alignItems: "center",
        borderRadius: Radius.lg,
        width: "100%",
        padding: Space.lg,
        gap: Space.sm,
    },
    body: {
        alignItems: "center",
        gap: Space.xxs,
        flexShrink: 0,
    },
});
